import UserGrowthChart from './UserGrowthChart';

export default UserGrowthChart;
